/* Inkaroo: keeps "Extra Print" basket lines in step with the designed garment they belong to.
   Garment lines and their extra print lines share the hidden "_Design ref" property. Each extra line carries
   "_Per garment"; garment lines carry "_Extras" (which extra lines belong to the design).
   Extra qty = garments with that ref x _Per garment: removing the garment removes its extras, and an extra line
   removed on its own is put back while the garment is still in the basket. */
(function () {
  'use strict';
  var busy = false;
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function post(url, body) {
    return fetch(root() + url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.ok; });
  }
  function sync() {
    if (busy) return Promise.resolve(false);
    busy = true;
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var garments = {}, specs = {}, have = {}, updates = {}, n = 0, add = [];
        cart.items.forEach(function (i) {
          var p = i.properties || {}, ref = p['_Design ref'];
          if (!ref || p['_Per garment']) return;
          garments[ref] = (garments[ref] || 0) + i.quantity;
          if (!specs[ref] && p['_Extras']) { try { specs[ref] = JSON.parse(p['_Extras']); } catch (e) { specs[ref] = []; } }
        });
        cart.items.forEach(function (i) {
          var p = i.properties || {}, ref = p['_Design ref'], per = parseInt(p['_Per garment'], 10);
          if (!ref || !per) return;
          have[ref + ':' + i.variant_id] = 1;
          var want = (garments[ref] || 0) * per;
          if (want !== i.quantity) { updates[i.key] = want; n++; }
        });
        Object.keys(specs).forEach(function (ref) {
          (specs[ref] || []).forEach(function (x) {
            if (!x || !x.v || have[ref + ':' + x.v] || !garments[ref]) return;
            add.push({ id: x.v, quantity: garments[ref] * (x.n || 1), properties: { 'For': x.f || ref, 'Position': x.p || '', '_Design ref': ref, '_Per garment': String(x.n || 1) } });
          });
        });
        if (!n && !add.length) return false;
        var job = Promise.resolve(true);
        if (n) job = job.then(function () { return post('cart/update.js', { updates: updates }); });
        if (add.length) job = job.then(function () { return post('cart/add.js', { items: add }); });
        return job;
      })
      .catch(function () { return false; })
      .then(function (changed) { busy = false; return changed; });
  }
  function syncAndRefresh() {
    sync().then(function (changed) { if (changed) window.location.reload(); });
  }
  // Extra print lines follow the garment quantity, so their own quantity box and remove link are hidden.
  function lockRows() {
    document.querySelectorAll('cart-items a[href*="/products/extra-print"], cart-drawer-items a[href*="/products/extra-print"]').forEach(function (a) {
      var row = a.closest('tr, .cart-item'); if (!row || row.hasAttribute('data-ink-locked')) return;
      row.setAttribute('data-ink-locked', '');
      row.querySelectorAll('quantity-input, cart-remove-button, .cart-item__quantity-wrapper .quantity').forEach(function (q) { q.style.display = 'none'; });
      var cell = row.querySelector('.cart-item__quantity') || row.querySelector('.cart-item__details');
      if (cell && !cell.querySelector('.ink-extra-note')) {
        var note = document.createElement('p'); note.className = 'ink-extra-note';
        note.style.cssText = 'margin:.4rem 0 0;font-size:1.25rem;line-height:1.4;opacity:.75;';
        note.textContent = 'Linked to your design: changes with the garment quantity.';
        cell.appendChild(note);
      }
    });
  }
  window.InkCartExtras = { sync: sync };
  function start() {
    lockRows();
    if ('MutationObserver' in window) document.querySelectorAll('cart-items, cart-drawer').forEach(function (el) { new MutationObserver(lockRows).observe(el, { childList: true, subtree: true }); });
    if (/\/cart\/?$/.test(window.location.pathname)) syncAndRefresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  // Dawn publishes cartUpdate after quantity changes / removals in the cart page and cart drawer.
  /* global subscribe, PUB_SUB_EVENTS */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
      if (e && e.source === 'product-form') return;
      setTimeout(syncAndRefresh, 50);
    });
  }
})();
